import { isAbortError } from '@reatom/framework';
import { isApiCancel } from '@/js/libs/api/index.ts';
const isCancelError = (error) => isApiCancel(error) || isAbortError(error);
export default isCancelError;
